/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';

const WriteAReviewPage = () => (
    <div
        id="pr-write"
        style={{
            width: '100%',
            maxWidth: '1400px',
            margin: '2em auto',
            padding: '0 30px',
        }}
    />
);
export default WriteAReviewPage;
